const getSubscribeButtonText = (user) => {
    if (!user || !user.type) return "Je teste gratuitement";

    return "Je m'abonne";
};

export default getSubscribeButtonText;
